import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 58,
    s: 58
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) {
              h--;
            } else {
              clearInterval(timer);
              return {
                h: 0,
                m: 0,
                s: 0
              };
            }
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const Block = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="bg-white border border-[#D5DCE5] rounded-xl px-4 py-3 min-w-[72px] md:min-w-[88px] text-center shadow-sm" data-id="element-10">
      <div className="text-3xl md:text-5xl text-[#1E3A5F] font-mono leading-none" style={{
      fontFamily: "'DM Serif Display', serif"
    }} data-id="element-11">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-[10px] md:text-xs text-[#2D9596] mt-1 uppercase tracking-[0.2em] font-sans font-bold" data-id="element-12">
        {label}
      </div>
    </div>;
  return <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-13">
      <Block value={timeLeft.h} label="hs" data-id="element-14" />
      <span className="text-2xl md:text-4xl text-[#2D9596] pb-4" data-id="element-15">:</span>
      <Block value={timeLeft.m} label="min" data-id="element-16" />
      <span className="text-2xl md:text-4xl text-[#2D9596] pb-4" data-id="element-17">:</span>
      <Block value={timeLeft.s} label="seg" data-id="element-18" />
    </div>;
}